import utils from './QSUtils';

const bootstrap = require('bootstrap');

export default {
    tooltipInitialize() {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    },
    popoverDocumentListener() {
        const documentClickPopover = (e: any) => {
            const popovers = document.querySelectorAll('.popover');
            if (!e.target.closest('div.popover') && popovers.length > 0) {
                // If the element clicked was the popover launcher, then do not close it
                const classList = e.target.classList;
                let css = [];
                if (classList.value.indexOf(' ') >= 0) {
                    css = classList.value.split(' ');
                } else {
                    css.push(classList.value);
                }

                // Check to see if the popover has a class of popover-manual-close-only.  If so prevent document click from closing
                const popoverClassList = popovers[0].classList;
                let popoverCss = [];
                if (popoverClassList.value.indexOf(' ') >= 0) {
                    popoverCss = popoverClassList.value.split(' ');
                } else {
                    popoverCss.push(popoverClassList.value);
                }

                if ((css.length > 0 && utils.isValueInArray(css, 'launch-popover')) || utils.isValueInArray(popoverCss, 'popover-manual-close-only')) {
                    return;
                }

                // Close all popovers if document is clicked but not on the popover itself
                if (!e.target.closest('div.popover')) {
                    popovers.forEach((item) => {
                        item.remove();
                    });
                }
            }
        };

        document.addEventListener('click', documentClickPopover);
    },
};
